import axios from 'axios';
import _ from 'lodash';

import { AbilityBuilder } from '@casl/ability';
import { PROZESSKONTROLLKARTE, WARENEINGANGSPRUEFUNG } from '@/constants/security/modules.type';
import {
  ACCESS, EDIT_ACTUAL, EDIT_PCK, READ_MANUFACTURING_ORDERS,
  READ_PCK, EXPORT, READ_COMPLETED, ASSIGN_PCK,
} from '@/constants/security/prozesskontrollkarte/ability.type';

import {
  ACCESS as ACCESS_WEP, EDIT_WEP, READ_WEP, EDIT_ACTUAL as EDIT_ACTUAL_WEP, READ_COMPLETED as READ_COMPLETED_WEP,
} from '@/constants/security/wareneingangspruefung/ability.type';

function canAccessProzesskontrollkarte(abilities) {
  const a = abilities[PROZESSKONTROLLKARTE];
  return a[READ_PCK] || a[EDIT_PCK] || a[EXPORT] || a[EDIT_ACTUAL] || a[READ_COMPLETED] || a[READ_MANUFACTURING_ORDERS] || a[ASSIGN_PCK];
}

function canAccessWareneingangspruefung(abilities) {
  const a = abilities[WARENEINGANGSPRUEFUNG];
  return a[READ_WEP] || a[EDIT_WEP] || a[EDIT_ACTUAL_WEP] || a[READ_COMPLETED_WEP];
}

export function defineAbilities(user) {
  const { rules, can } = new AbilityBuilder();
  _.toPairs(user.abilities).forEach(([module, abilities]) => {
    _.toPairs(abilities).forEach(([ability, hasAbility]) => {
      if (hasAbility) {
        can([ability], module);
      }
    });
  });

  const { abilities } = user;

  if (canAccessProzesskontrollkarte(abilities)) {
    can(ACCESS, PROZESSKONTROLLKARTE);
  }

  if (canAccessWareneingangspruefung(abilities)) {
    can(ACCESS_WEP, WARENEINGANGSPRUEFUNG);
  }

  if (abilities[PROZESSKONTROLLKARTE][ASSIGN_PCK]) {
    can(READ_MANUFACTURING_ORDERS, PROZESSKONTROLLKARTE);
  }

  if (abilities[PROZESSKONTROLLKARTE][EDIT_PCK]) {
    can(READ_PCK, PROZESSKONTROLLKARTE);
  }

  if (abilities.casl.manage_users || abilities.casl.manage_usergroups || abilities.casl.manage_abilities) {
    can('manage', 'casl');
  }

  if (abilities.presentation_display.manage) {
    can('manage', 'settings');
  }

  can('access', 'ressources'); // TODO
  can('manage_base_data', 'ressources'); // TODO
  can('administrative_rights', 'ressources'); // TODO
  can('access', 'standards'); // TODO
  can('manage_base_data', 'standards'); // TODO
  can('administrative_rights', 'standards'); // TODO

  return rules;
}

export async function loadAbilities() {
  const response = await axios.get('/bx-casl-api/v1/user/ability', { withCredentials: true });
  return response.data;
}
